import { createRoot } from 'react-dom/client'
import ShopTheLookImageDrawer from './components/ShopTheLookImageDrawer'

const mountAll = (scope: ParentNode = document) => {
  scope.querySelectorAll<HTMLElement>('[data-shop-the-look-image-drawer]').forEach((mount) => {
    if (mount.dataset.mounted === 'true') return

    mount.dataset.mounted = 'true'
    createRoot(mount).render(<ShopTheLookImageDrawer mount={mount} />)
  })
}

mountAll()

/* Re-mount when the merchant edits the section in the theme editor. */
document.addEventListener('shopify:section:load', (event: any) => {
  mountAll(event.target || document)
})
